import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-auth',
    imports: [
        NgOptimizedImage,
        RouterOutlet
    ],
  templateUrl: './auth.html',
  styleUrl: './auth.css'
})
export class Auth {

}
